import * as tslib_1 from "tslib";
import { Message, Event } from 'grey-message';
import { compose } from 'grey-group-function';
import { BoxContext } from './Source';
import React from 'react';
export { default as Source } from './Source';
/** 数据盒子 */
var GreyReactBox = /** @class */ (function (_super) {
    tslib_1.__extends(GreyReactBox, _super);
    /** 数据盒子 */
    function GreyReactBox(state) {
        var _this = _super.call(this) || this;
        /** 动作计时器 */
        _this.actionTimer = undefined;
        /** 正在执行的函数列表 */
        _this.runingFunctions = [];
        /** 绑定另一个盒子 */
        _this.link = function (rb) {
            _this.boxState = rb.state;
            rb.on('STATE_CHANGE_EVENT', function () {
                _this.boxState = rb.state;
                _this.send(new StateChangeEvent());
            });
        };
        /**
         * 绑定组件(适用于页面开发)
         * @param reduxStatePart 一个返回全局对象片段的方法
         * @param isForm 是否关联 Form
         * @param react 当前适用的react的实例
         */
        _this.connect = function (reduxStatePart, react) {
            if (react === void 0) { react = React; }
            return function (Dom) { return function (props) {
                var _a = react.useState(reduxStatePart ? reduxStatePart(_this.boxState) : _this.boxState), connectState = _a[0], setConnectState = _a[1];
                /** 监听状态变化消息 */
                react.useEffect(function () { return _this.on(StateChangeEvent.TYPE, function () {
                    setConnectState(reduxStatePart ? reduxStatePart(_this.boxState) : _this.boxState);
                }); }, []);
                return (React.createElement(Dom, tslib_1.__assign({}, props, connectState)));
            }; };
        };
        /** 等待 */
        _this.wait = function (timeout) { return new Promise(function (resolve) {
            setTimeout(resolve, timeout);
        }); };
        /** 钩子容器 */
        _this.hooks = function (React) {
            /**
             * 绑定数据的钩子(弃用)
             */
            var useState = function (fn) {
                var _a = React.useState(fn ? fn(_this.boxState) : _this.boxState), state = _a[0], setState = _a[1];
                var onEffect = React.useCallback(function () { return _this.on(StateChangeEvent.TYPE, function () {
                    if (fn) {
                        setState(fn(_this.boxState));
                    }
                    else {
                        setState(_this.boxState);
                    }
                }); }, [fn]);
                React.useEffect(onEffect, []);
                return [state];
            };
            /**
             * 绑定数据的钩子(适用于组件开发)
             */
            var useMemo = function (fn, deps) {
                var _a = React.useState(fn(_this.boxState)), state = _a[0], setState = _a[1];
                var factory = React.useCallback(fn, deps);
                var runState = React.useCallback(function () { setState(factory(_this.boxState)); }, [factory]);
                var onEffect = React.useCallback(function () { return _this.on(StateChangeEvent.TYPE, runState); }, [runState]);
                React.useEffect(onEffect, []);
                React.useEffect(runState, deps);
                return state;
            };
            /** 方法是否在执行中的钩子（适用于组件开发） */
            var useRuning = function () {
                var fns = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    fns[_i] = arguments[_i];
                }
                var _a = React.useState(_this.isRuning.apply(null, fns)), runing = _a[0], setRuning = _a[1];
                var onEffect = React.useCallback(function () { return _this.on(StateChangeEvent.TYPE, function () {
                    setRuning(_this.isRuning.apply(null, fns));
                }); }, [fns]);
                React.useEffect(onEffect, []);
                return [runing];
            };
            return {
                /** 绑定数据的钩子(弃用) */
                useState: useState,
                /** 绑定数据的钩子(适用于组件开发) */
                useMemo: useMemo,
                /** 方法是否在执行中的钩子（适用于组件开发） */
                useRuning: useRuning
            };
        };
        /** 绑定数据的钩子(弃用) */
        _this.useState = _this.hooks(React).useState;
        /** 绑定数据的钩子(适用于组件开发) */
        _this.useMemo = _this.hooks(React).useMemo;
        /** 方法是否在执行中的钩子（适用于组件开发） */
        _this.useRuning = _this.hooks(React).useRuning;
        /** 方法是否在执行中 */
        _this.isRuning = function () {
            var fns = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                fns[_i] = arguments[_i];
            }
            if (!_this.runingFunctions) {
                return false;
            }
            else {
                var runingFunctions_1 = _this.runingFunctions;
                return fns.some(function (fn) { return runingFunctions_1.indexOf(fn) >= 0; });
            }
        };
        /** 添加已经执行的函数 */
        _this.addRunFunction = function (fn) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.runingFunctions.push(fn);
                setTimeout(function () { _this.send(new StateChangeEvent()); });
                return [2 /*return*/];
            });
        }); };
        /** 删除已经添加的执行函数 */
        _this.remRunFunction = function (fn) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var t;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                t = this.runingFunctions.indexOf(fn);
                if (t >= 0) {
                    this.runingFunctions.splice(t, 1);
                    setTimeout(function () { _this.send(new StateChangeEvent()); });
                }
                return [2 /*return*/];
            });
        }); };
        _this.action = _this.action.bind(_this);
        _this.pipeline = _this.pipeline.bind(_this);
        _this.useState = _this.useState.bind(_this);
        _this.boxState = state;
        return _this;
    }
    Object.defineProperty(GreyReactBox.prototype, "state", {
        /** 当前自己盒子 */
        get: function () {
            return this.boxState;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * 绑定修改数据的方法（弃用）
     * @param method 绑定的函数
     */
    GreyReactBox.prototype.action = function (method) {
        var _this = this;
        return function (option) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var newBoxState;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, method(this.boxState, option, this)];
                    case 1:
                        newBoxState = _a.sent();
                        clearTimeout(this.actionTimer);
                        this.actionTimer = setTimeout(function () {
                            _this.send(new StateChangeEvent());
                            _this.actionTimer = undefined;
                        });
                        return [2 /*return*/, newBoxState];
                }
            });
        }); };
    };
    /** 数据修改管道 */
    GreyReactBox.prototype.pipeline = function () {
        var _this = this;
        var method = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            method[_i] = arguments[_i];
        }
        var fn = function (option) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var ret, i;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addRunFunction(fn)];
                    case 1:
                        _a.sent();
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < method.length)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.action(method[i])(option)];
                    case 3:
                        ret = _a.sent();
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [4 /*yield*/, this.remRunFunction(fn)];
                    case 6:
                        _a.sent();
                        return [2 /*return*/, ret];
                }
            });
        }); };
        return fn;
    };
    /** 修改状态的快速通道 */
    GreyReactBox.prototype.run = function (fn) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pipeline(fn)()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return GreyReactBox;
}(Message));
export default GreyReactBox;
/** 装饰器 */
export function decorator() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function (puppet) { return compose.apply(null, fns.slice())(puppet); };
    ;
}
/** 获取box上下文 */
export function useContext() {
    return React.useContext(BoxContext);
}
/** 状态变化事件 */
var StateChangeEvent = /** @class */ (function (_super) {
    tslib_1.__extends(StateChangeEvent, _super);
    function StateChangeEvent() {
        return _super.call(this, StateChangeEvent.TYPE) || this;
    }
    StateChangeEvent.TYPE = 'STATE_CHANGE_EVENT';
    return StateChangeEvent;
}(Event));
export { StateChangeEvent };



//////////////////
// WEBPACK FOOTER
// ./node_modules/grey-react-box/dir/index.js
// module id = 4333
// module chunks = 0